/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import TablePagination from "@material-ui/core/TablePagination";

import PhotoCard from "./photoCard";
import SelectCompetition from "./selectCompetition";
import CartComponent from "../../components/Product/CartComponent";
import AccordionCategories from "./accordionCategories";
import PhotoCarousel from "./photoCarousel";
import SnackbarComponent from "../../components/Nav/SnackbarComponent";
import { useMutation, useQuery } from "@apollo/client";
import { ADD_TO_CART, GET_ALL_PRODUCTS, GET_SHOPPINGCART } from "../../queries";
// import { ADD_TO_CART } from '../../queries';
import { useThemeData } from "../../context/ThemeDataContext";
import { useMediaQuery } from "@material-ui/core";
import GeneralButton from "../../components/Buttons";
import Hidden from '@material-ui/core/Hidden';
import GeneralText from "../../components/Fonts";
/* EQUESTRIAN Event*/

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    marginBottom: "1rem",
    padding: "0.5rem",
    backgroundColor: "white",
    borderRadius: "0.5rem",
    boxShadow: "#adb5bd 1px 1px 2px 1px",
  },
  cart: {
    height: "fit-content",
  },
  cartTitle: {
    margin: "1.5rem 0rem 0.5rem 0rem",
    textAlign: "center",
    fontWeight: "bold",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    fontWeight: "bold",
  },
  staticAccordion: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "bold",
  },
  staticAccordionSummary: {
    display: "block",
    margin: "0",
    minHeight: "30px",
  },
  title: {
    fontWeight: "bold",
    margin: "1.5rem 0rem 0.5rem 0rem",
  },
  button: {
    margin: "0.5rem",
    width: "-webkit-fill-available",
  },
}));

function Event(props) {
  const classes = useStyles();
  const { photographerType } = useThemeData();
  const { font_family, primary_color_2 } = useThemeData().themeData.site.theme;
  const { folder_naam, folderchildren, user_id, site_id, keuzeset_id } =
      props.location.state.data;
  const [data, setData] = useState([]);

  const folderID = useParams().folderID;


  const [selected_folder_id, setSelectedFolderID] = useState(null); //class
  const [selected_folder, setSelectedFolder] = useState([]); // class

  const [first_photo_folder_id, setFirstFolderID] = useState(
      folderchildren.length > 0
          ? folderchildren[0].folderchildren.length > 0
              ? folderchildren[0].folderchildren[0].photos.length > 0
                  ? folderchildren[0].folderchildren[0].photos[0].folder_id
                  : null
              : null
          : null
  ); //album
  const [first_photo_album_name, setFirstFolderAlbumName] = useState(
      folderchildren.length > 0
          ? folderchildren[0].folderchildren.length > 0
              ? folderchildren[0].folderchildren[0].photos.length > 0
                  ? folderchildren[0].folderchildren[0].folder_naam
                  : null
              : null
          : null
  ); // album
  const [first_photo, setFirstPhoto] = useState(null);
  const [first_photo_id, setFirstPhotoID] = useState(null);

  const [photos, setPhotos] = useState([]);

  const [pageInfo, setPageInfo] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [page, setPage] = useState(0);

  const [cartUpdated, setCartUpdated] = useState(false);
  const login = photographerType;
  const firstPartLogin = login !== null ? login.replace('["', "") : "";
  const MiddelPartLogin = firstPartLogin.replace('","', ", ");
  const login_name = MiddelPartLogin.replace('"]', "");
  const [logins] = useState({ login_name });

  const [isSet, setIsSet] = useState(false);
  const shippingMethod = localStorage.hasOwnProperty("shippingMethod")
      ? localStorage.getItem("shippingMethod")
      : '';
  const isMobile = useMediaQuery("(max-width:768px)");
  const [SnackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const snackbar = { message: props.t("Added to shoppingcart") };
  const closeSnackbar = () => {
    setSnackbarIsOpen(false);
  };

  const {
    error: errorPhotos,
    loading: loadingPhotos,
    data: dataPhotos,
    refetch: refetchPhotos,
  } = useQuery(GET_ALL_PRODUCTS, {
    variables: {
      site_id: site_id,
      login_name: "",
      folder_id: first_photo_folder_id,
      first: rowsPerPage,
      page: page + 1,
    },
    skip: site_id === "" || first_photo_folder_id === null,
  });

  useEffect(() => {
    if (!loadingPhotos && !errorPhotos) {
      async function fetchData() {
        let response = await dataPhotos;
        if (response && dataPhotos) {
          setData(dataPhotos.photos.data);
          setPageInfo(dataPhotos.photos.paginatorInfo);
          setIsSet(false);
        }
      }
      fetchData();
    }
  }, [dataPhotos, errorPhotos, loadingPhotos]);

  const [
    createShoppingcart,
    { loading: loadingCreateShoppingCart},
  ] = useMutation(ADD_TO_CART, {
    onCompleted: () => {
    console.log('hier?')
      //
      // refetchPhotos({
      //   variables: {
      //     site_id: site_id,
      //     login_name: [logins],
      //     folder_id: first_photo_folder_id,
      //   },
      // });
      setSnackbarIsOpen(true);
    },
    onError: (error) => {
      console.error(error);
    },
    refetchQueries: [
      {
        query: GET_SHOPPINGCART,
        variables: {
          session_id: localStorage.getItem("session_id"),
          site_id: site_id,
          login_name: [logins],
          shipping_method: shippingMethod
        },
      },
    ],
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data.length > 0) {
      setPhotos(data);
      setFirstPhotoID(data[0].id);
      setFirstPhoto(data[0].file_name);
      setSelectedFolderID(data[0].folder.class_id);
      setSelectedFolder(data[0].folder.class_name);
      localStorage.setItem('event_id',folderID);

    }
  }, [data, folderID]);

  useEffect(() => {
    if (first_photo_folder_id) {
      refetchPhotos({
        variables: {
          site_id: site_id,
          login_name: "",
          folder_id: first_photo_folder_id,
        },
      });
    }
  }, [first_photo_folder_id, site_id, refetchPhotos]);

  const onChange = (e) => {
    const { value } = e.target;
    setSelectedFolderID(value); // class id
    setFirstFolderID(
        folderchildren.find((f) => f.folder_id === value).folderchildren[0]
            .folder_id
    ); // album id
    setFirstFolderAlbumName(
        folderchildren.find((f) => f.folder_id === value).folderchildren[0]
            .folder_naam
    ); // album name
  };

  const changePhoto = (id, fID, type) => {
    const folder_id = fID;
    // const file_id = photos.find((p) => p.id === id).id;
    const file_name = photos.find((p) => p.id === id).file_name
    setFirstPhoto(file_name);
    setFirstPhotoID(photos.find((p) => p.id === id).id);
    setFirstFolderID(folder_id);
    setFirstFolderAlbumName(
        folderchildren
            .find((f) => f.folder_id === selected_folder_id)
            .folderchildren.find((f) => f.folder_id === folder_id).folder_naam
    );
    if (type !== "carousel") {
      const element = document.getElementById("photoCarousel");
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  function handleChangePage(event, value) {
    setPage(value);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(event.target.value);
  }

  const goTo = () => {
    let location = {
      pathname: `/`,
    };
    props.history.push(location);
  };

  async function addTo(e, data) {
    let categories = data.map((c) => ({
      categorie_id: c.categorie_id,
      naam: c.naam,
      catproducts: c.catproducts
          .filter((f) => f.checked === true)
          .map((p) => ({
            categorie_id: c.categorie_id,
            categorie_naam: c.naam,
            product_id: p.product_id,
            actie_prijs: p.actie_prijs,
            formaat: p.formaat,
            naam: p.naam,
            prijs: p.prijs,
            quantum_aantal: p.quantum_aantal,
            quantum_perc: p.quantum_perc,
            product_format: p.product_format,
            shippingcost: p.shippingcost,
            productpakketdetails: p.productpakketdetails,
          })),
    }));
    let newData = [];
    let cartproducts = [];
    categories
        .filter((f) => f.catproducts.length > 0)
        .map((n) => (cartproducts = cartproducts.concat(n.catproducts)));
    newData = cartproducts.map((p) => ({
      session_id: localStorage.getItem("session_id"),
      site_id: localStorage.getItem("site_id"),
      login_name: logins,
      product_categorie: p.categorie_naam,
      product_id: p.product_id,
      product_name: p.naam,
      product_format: p.formaat,
      product_file:
          p.productpakketdetails.length > 0
              ? p.productpakketdetails[0].productdetail.product_file
              : `${first_photo}`,
      shippingcost: p.shippingcost,
      photo_id: first_photo_id,
      image_effect: "Kleur",
      effect_file_name: null,
      effect_file_id: 0,
      amount: 1,
      totaalprijs: null,
      oorspronkelijke_prijs_ps: p.prijs,
      prijs_ps: p.actie_prijs,
      shoppingcart_rules:
          p.productpakketdetails.length > 0
              ? p.productpakketdetails.map((pakket) => ({
                session_id: localStorage.getItem("session_id"),
                product_id: pakket.product_id,
                product_name: pakket.productdetail.naam,
                product_file: pakket.productdetail.product_file,
                product_format: pakket.productdetail.product_format,
                product_categorie: p.categorie_naam,
                totaalprijs: pakket.productdetail.actie_prijs,
                oorspronkelijke_prijs_ps: pakket.productdetail.prijs,
                prijs_ps: pakket.productdetail.actie_prijs,
                effect_file_name: null,
                effect_file_id: 0,
                photo_id: first_photo_id,
                image_effect: "kleur",
                amount: "1",
              }))
              : [],
    }));

    if (newData.length > 0) {
      e.preventDefault();
      e.stopPropagation();
      if (!loadingCreateShoppingCart) {
        let promise;
        promise = new Promise(function(resolve, reject) {
          resolve(createShoppingcart({
            variables: {
              input: newData,
            },
          }));
        })
        return promise.then(() => {
          setCartUpdated(true);
          return(setIsSet(false))
        })
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  };


  if (errorPhotos) return <p>{props.t("Looks like we have a problem...")}</p>;
  if (!pageInfo) return null;

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      className="event"
      style={{ fontFamily: `${font_family}`, color: `${primary_color_2}` }}
    >
      <Grid container direction="row">
        <GeneralButton className="" onClick={() => goTo()}                 style={{
          marginBottom: '15px'
        }}>
          Terug naar alle evenementen
        </GeneralButton>
      </Grid>

      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Grid
            container
            direction="row"
            className={`${classes.container} event-card bottom-card`}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <GeneralText
                className={classes.title}
                color={primary_color_2}
                variant="subtitle1"
                gutterBottom={true}
                style={{
                  textAlign: 'left'
                }}
              >
                {folder_naam}
              </GeneralText>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SelectCompetition
                {...props}
                data={folderchildren}
                onChange={onChange}
                selected={selected_folder_id}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            spacing={1}
            className={`${classes.container}`}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="event-card-small"
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <GeneralText
                  className={classes.title}
                  color={primary_color_2}
                  variant="subtitle1"
                  gutterBottom={true}
                >
                  {folder_naam}
                </GeneralText>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <SelectCompetition
                  {...props}
                  data={folderchildren}
                  onChange={onChange}
                  selected={selected_folder_id}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <GeneralText
                className={classes.title}
                color={primary_color_2}
                variant="subtitle2"
              >
                {selected_folder}
                {","} {first_photo_album_name}: {first_photo_id}
              </GeneralText>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} />
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} id="photoCarousel">
              <PhotoCarousel
                {...props}
                site_id={site_id}
                selected_photo_id={first_photo_id}
                photos={photos}
                changePhoto={changePhoto}
                loadingPhotos={loadingPhotos}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {isMobile && SnackbarIsOpen && (
                <SnackbarComponent
                  closeSnackbar={closeSnackbar}
                  message={snackbar.message}
                  severity={"success"}
                />
              )}
              <AccordionCategories
                {...props}
                data={data}
                isSet={isSet}
                setIsSet={setIsSet}
                addTo={addTo}
                photo_id={first_photo_id}
                keuzeset_id={keuzeset_id}
              />
            </Grid>
          </Grid>
          <Grid container direction="row">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SelectCompetition
                {...props}
                data={folderchildren}
                onChange={onChange}
                selected={selected_folder_id}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <GeneralText
                  style={{
                    textAlign: 'left'
                  }}
                color={primary_color_2}
                variant="h5"
                gutterBottom={true}
              >
                {selected_folder}
              </GeneralText>
            </Grid>
          </Grid>
          <Hidden lgUp mdUp>
            <Grid item xl={3} className={[classes.container, classes.cart]}>
              <GeneralText
                color={primary_color_2}
                className={classes.cartTitle}
                variant="subtitle1"
                gutterBottom={true}
              >
                {props.t("Artikelen in de winkelwagen")}
              </GeneralText>
              {data.length > 0 && (
                <CartComponent
                  {...props}
                  type="equestrianPhotoService"
                  user_id={user_id}
                  cart={true}
                  cartUpdated={cartUpdated}
                  setCartUpdated={setCartUpdated}
                  data={data}
                />
              )}
            </Grid>
          </Hidden>
          {loadingPhotos ? (
            <LinearProgress
              className="align-self-center"
              style={{ color: primary_color_2 }}
            />
          ) : (
            <Grid container direction="row" spacing={1}>
              {data.map((d, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={d.id}>
                  <GeneralButton
                    className="photo-tile-btn"
                    style={{ width: "-webkit-fill-available" }}
                    onClick={() => changePhoto(d.id, d.folder.folder_id)}
                  >
                    <PhotoCard data={d} index={index} site_id={site_id} />
                  </GeneralButton>
                </Grid>
              ))}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TablePagination
                  className="overflow-hidden flex-shrink-0 tablepagination"
                  style={{ display: "flex", justifyContent: "center" }}
                  component="div"
                  count={pageInfo.total ? pageInfo.total : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelRowsPerPage={props.t("events:Rows per page")}
                  backIconButtonProps={{
                    "aria-label": "Previous Page",
                  }}
                  nextIconButtonProps={{
                    "aria-label": "Next Page",
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  SelectProps={{ native: true }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
        <Hidden xsDown>
          <Grid
            item
            md={3}
            lg={3}
            sx={{
              display: { xs: "none", lg: "block" },
            }}
            className={[classes.container, classes.cart]}
          >
            <GeneralText
              color={primary_color_2}
              className={classes.cartTitle}
              variant="subtitle1"
              gutterBottom={true}
            >
              {props.t("Artikelen in de winkelwagen")}
            </GeneralText>
            {data.length > 0 && (
              <CartComponent
                {...props}
                type="equestrianPhotoService"
                user_id={user_id}
                cart={true}
                cartUpdated={cartUpdated}
                setCartUpdated={setCartUpdated}
                data={data}
              />
            )}
          </Grid>
        </Hidden>
      </Grid>
    </Grid>
  );
}

export default React.memo(withTranslation(["home", "message"])(Event));
